import React, { Component } from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';

import { LAZY_DEFAULTS } from '../../constants';

export default function withLazy(WrappedComponent) {
  class LazyWrapper extends Component {
    constructor(props) {
      super(props);
      const { items, pagination } = props;
      const page = 0;
      const total = pagination.count;
      const viewableItems = items.length ? items : [];
      const loading = !items || items.length === 0;
      this.state = {
        loading,
        page,
        total,
        viewableItems,
      };
      this.showMore = throttle(this.showMore, 2000, { trailing: false }).bind(this);
    }

    componentWillReceiveProps(nextProps) {
      const { items: nextItems, pagination: nextPagination } = nextProps;
      if (this.sizeOrSortChange(this.props, nextProps)) {
        const total = nextPagination.count;
        this.setState({
          loading: false,
          total,
          viewableItems: nextItems,
        });
      }
    }

    sizeOrSortChange(props, nextProps) {
      const { items } = props;
      const { items: nextItems } = nextProps;
      if (!nextItems) {
        return false;
      }
      return items !== nextItems;
    }

    showMore() {
      const { pagination } = this.props;
      if (pagination.page < Math.floor(this.state.total / LAZY_DEFAULTS.INITIAL)) {
        const { filters, sort, setProperties } = this.props;
        const page = pagination.page + 1;
        setProperties(filters, sort, page);
      }
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          showMore={this.showMore}
          total={this.state.total}
          items={this.state.viewableItems}
          loading={this.state.loading}
        />);
    }
  }

  LazyWrapper.propTypes = {
    items: PropTypes.arrayOf(PropTypes.object),
    sort: PropTypes.arrayOf(PropTypes.string),
    pagination: PropTypes.object,
    filters: PropTypes.object,
    setProperties: PropTypes.func,
  };

  return LazyWrapper;
}



// WEBPACK FOOTER //
// ./src/components/WithLazy/WithLazy.js